import React from "react";
import cns from "classnames";
import Grid from "@material-ui/core/Grid";
import Body from "./typography/Body";
import { Label } from "./typography/Label";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    ...theme.mixins.childrenMarginRight(theme.spacing(1 / 2)),

    "& > div": {
      width: "100%",
      wordBreak: "break-word"
    }
  },
  content: {
    ...theme.mixins.childrenMarginBottom(theme.spacing(1 / 2))
  },
  label: {
    color: theme.descriptionColor
  }
}));

type Props = {
  className?: string;
  icon?: React.ReactNode;
  title: React.ReactNode;
  content?: React.ReactNode;
  children?: React.ReactNode;
};

export function ContactDetail(props: Props) {
  const classes = useStyles({});
  const content = props.content ? props.content : props.children;

  return (
    <Grid container spacing={0} className={cns(classes.root, props.className)}>
      {props.icon && <Grid item>{props.icon}</Grid>}

      {(props.title || content) && (
        <Grid item>
          <Grid container direction="column" spacing={0} className={classes.content}>
            {props.title && (
              <Grid item className={classes.label}>
                <Label>{props.title}</Label>
              </Grid>
            )}

            {content && (
              <Grid item>
                <Body>{content}</Body>
              </Grid>
            )}
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
